import React, { useState } from 'react'

import axios from 'axios'
import { Delete, DeleteOutline, Edit, EditOutlined } from '@material-ui/icons'
import EditSubSectionModal from './EditSubSectionModal'
import SubsectionDelete from './SubsectionDelete'
import { IconButton } from '@material-ui/core'

import iziToast from 'izitoast'
import { useStoreon } from 'storeon/react'

interface ActionsCellProps {
	onEdit: () => void
	onDelete: () => void
	onDeleteSuccess?: () => void
	onEditSuccess?: () => void
	_id: string
	createdBy: string

	rowData: any
}

const ActionsCell: React.FC<ActionsCellProps> = ({
	onEdit,
	onDelete,
	rowData,
	onDeleteSuccess,
	onEditSuccess,
	_id,
	createdBy
}) => {
	const [openDeleteModal, setOpenDeleteModal] = useState(false)
	const [openEditModal, setOpenEditModal] = useState(false)
	const [hoveredButton, setHoveredButton] = useState<'edit' | 'delete' | null>(null)
	const { token } = useStoreon('token')
	const handleEdit = () => {
		setOpenEditModal(true)
		onEdit()
	}

	const handleDelete = async () => {
		try {
			await axios.delete(
				`${process.env.REACT_APP_API_URL}/api/v1/custom/deleteSubSection`,
				{
					data: {
						subSectionId: rowData._id,
						userId: rowData.createdBy
					},
					headers: {
						Authorization: `${token}`
					}
				}
			)

			iziToast.success({
				message: 'SubSection deleted successfully!'
			})

			onDelete()
			onDeleteSuccess?.()

			setTimeout(() => {
				setOpenDeleteModal(false)
			}, 100)
		} catch (error: any) {
			console.error('Delete Error:', error)

			const errorMessage =
				error?.response?.data?.message || 'Something went wrong while deleting.'

			iziToast.error({
				message: errorMessage
			})

			setOpenDeleteModal(false)
		}
	}

	const handleSave = (updatedData: typeof rowData) => {
		// console.log('Updated Data:', updatedData)
		setOpenEditModal(false)
		onEditSuccess?.()
	}

	return (
		<div style={{}}>
			<IconButton
				onClick={handleEdit}
				title="Edit"
				onMouseEnter={() => setHoveredButton('edit')}
				onMouseLeave={() => setHoveredButton(null)}
				style={{
					color: '#7D6EF1'
				}}
			>
				<Edit />
			</IconButton>

			<IconButton
				onClick={() => setOpenDeleteModal(true)}
				title="Delete"
				onMouseEnter={() => setHoveredButton('delete')}
				onMouseLeave={() => setHoveredButton(null)}
				style={{ color: 'red' }}
			>
				<DeleteOutline />
			</IconButton>

			{/* Delete Confirmation Modal */}
			<SubsectionDelete
				open={openDeleteModal}
				onClose={() => setOpenDeleteModal(false)}
				handleDelete={handleDelete}
			/>

			{/* Edit Modal */}
			<EditSubSectionModal
				open={openEditModal}
				onClose={() => setOpenEditModal(false)}
				rowData={rowData}
				onUpdated={handleSave}
			/>
		</div>
	)
}

export default ActionsCell
